// @flow
import * as React from 'react';

import { Outlet } from 'react-router-dom';

import { compose } from 'redux';

import { withPageMeta } from '@gandi/app-runner';
import { needsAuth } from '@gandi/authentication';

function Cloud() {
  return <Outlet />;
}

export default (compose(
  withPageMeta(args => ({
    title: args.__('Buy cloud server - Gandi.net'),
    description: args.__(
      'Gandi Cloud Servers - Create a Cloud Server in a minute.',
    ),
  })),
  needsAuth,
)(Cloud): React.ComponentType<{}>);
